import React, { useEffect, useState } from "react";
import NavBar from "./NavBar";
import { db } from "./Firebase";
import {
  setDoc,
  collection,
  getDocs,
  query,
  doc,
  where,
} from "firebase/firestore";
import toast from "react-hot-toast";
import emailjs from "@emailjs/browser";
import BackgroundVid from "../assets/video.mp4";
// import { LoadingOutlined } from '@ant-design/icons';
// import { Spin } from 'antd';
import qrCode from "../assets/StoreQrCode.png";
import { motion } from "framer-motion";
import Banner from "./Banner";

export const isValidEmail = (email) =>
  /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
export const toDateTime = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Add leading zero for single-digit months
  const day = String(date.getDate()).padStart(2, "0"); // Add leading zero for single-digit days
  const hours = String(date.getHours()).padStart(2, "0"); // Add leading zero for single-digit hours
  const minutes = String(date.getMinutes()).padStart(2, "0"); // Add leading zero for single-digit minutes
  const seconds = String(date.getSeconds()).padStart(2, "0"); // Add leading zero for single-digit seconds

  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};
//changeModal({show: true, data: {fullname: '', businessname: '', location: '', website: '', countrycode: '+961', phone: '', businessemail: ''}})

const Home = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const colRef = collection(db, "signups");

  // const getData = async () => {
  //   const data = await getDocs(query(colRef));
  //   console.log(data.docs)
  //   data.forEach((doc) => {
  //     // doc.data() is never undefined for query doc snapshots
  //     //console.log(doc.id, " => ", doc.data());
  //     deleteDoc(doc.ref)
  //   });
  // }

  const signup = async () => {
    try {
      if (loading) return;
      if (!email.trim() || !name.trim() || !isValidEmail(email)) return;
      setLoading(true);
      const docSearch = await getDocs(
        query(colRef, where("email", "==", email))
      );
      if (docSearch.docs.length == 0) {
        await setDoc(doc(colRef), { email, name, entry_date: toDateTime() });
        //grg76XmeXnwqwv5cy
        emailjs
          .send(
            "service_h4br5is",
            "template_3bi0wub",
            { name, email },
            { publicKey: "grg76XmeXnwqwv5cy" }
          )
          .then(
            (response) => {
              window.location.replace("/thanks");
              console.log("SUCCESS!", response.status, response.text);
            },
            (error) => {
              console.log("FAILED...", error);
              setLoading(false);
              toast("Error sending email", {
                icon: "⚠️",
              });
              //setLoading(false);
            }
          );

        //toast.success("Thank you for signing up!")
      } else {
        //console.log("Already exists");
        setLoading(false);
        toast("You have already subscribed", {
          icon: "⚠️",
        });
        //setLoading(false);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
      toast("An error has occured", { icon: "⚠️" });
    }
  };

  useEffect(() => {
    //getData()
  }, []);
  const textVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, delay: 0.3 } },
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };
  return (
    <div style={{ position: "relative" }} id="msection1">
      <video playsInline autoPlay muted className="myvid" id="myvid">
        <source src={BackgroundVid} type="video/mp4"></source>
      </video>
      <Banner />
      <NavBar />

      {/* <div className='light-blue-circle' /> */}

      {/* <div className='big-yellow-circle' /> */}

      {/* <div className='2phones'> */}
      {/* <img alt='2 phones' src={twophones} className='twophones' /> */}
      {/* </div> */}

      <motion.div
        className="home-main-text-div"
        initial="hidden"
        animate="visible"
        variants={containerVariants}
      >
        <motion.div className="intro-bg" variants={textVariants}>
          <motion.h1 className="title light-text" variants={textVariants}>
            YOUR <span className="bold-title">GO-TO</span>
          </motion.h1>
          <motion.h1 className="bold-title" variants={textVariants}>
            PERSONAL CARE <span className="light-text">SOURCE</span>
          </motion.h1>
          <motion.p className="light-text home-p" variants={textVariants}>
            TheBooker connects you with professional personal care service
            providers in your home area or in an area you’re visiting, whether
            you’re looking for a simple skincare or a physiotherapy.
          </motion.p>
        </motion.div>
      </motion.div>
      <div className="home-main-subscribe-div">
        {/* 
        <p className='first-to-know'>BE THE FIRST TO KNOW WHEN WE LAUNCH!</p>
            <input value={name} onChange={(e) => setName(e.target.value)} type='text' placeholder='Name' className='home-input' />
            <input value={email} onChange={(e) => setEmail(e.target.value)} type='email' placeholder='Email' className='home-input' />
            <div 
            className='subscribe-btn' 
            style={{marginTop: 15, opacity: loading ? 0.5 : 1}}
            onClick={() => !email.trim() || !name.trim() || !isValidEmail(email) ?  toast("Please enter your name & email", {icon: '⚠️'}) : signup()}
            >
              {!loading ?
              <p>SUBSCRIBE</p>
              :
              <Spin
              indicator={
                <LoadingOutlined
                  style={{
                    fontSize: 24,
                    color: 'white'
                  }}
                  spin
                />
              }
            />
              }
            </div>*/}

        {/* QrCode Container only visible on web ==> */}
        <div className="qrCodeContainer">
          <p className="scan-to-download"> SCAN & DOWNLOAD</p>
          <img
            src={qrCode}
            width={160}
            height={160}
            style={{ marginTop: "20px" }}
          />
        </div>
        {/* Download Buttons is Visible on Mobile => */}
        <div
          className="downloadbtn"
          onClick={(event) => (window.location.href = "/store")}
        >
          <p> DOWNLOAD NOW</p>
        </div>

        <div className="downloadButtonsContainer">
          <div className="StoreButtons">
            <div id="IOS">
              <a target="_blank" className="market-btn apple-btn" role="button">
                <span className="market-button-subtitle">Download on the</span>
                <span className="market-button-title">App Store</span>
              </a>
            </div>
            <div id="Droid">
              <a
                target="_blank"
                className="market-btn google-btn"
                role="button"
              >
                <span className="market-button-subtitle">Get it on</span>
                <span className="market-button-title">Google Play</span>
              </a>
            </div>
          </div>
        </div>
        <p className="RegisterBusiness">
          Register your business with us{" "}
          <a href="#business" style={{ color: "#008a80" }}>
            here
          </a>
        </p>
      </div>
    </div>
  );
};

export default Home;
